import { type ImageVersion, type StreamingContent, type StreamingProviderContent, type WatchableContent } from "src/lib/movieinfo/movieinfotypes";
import { isStreamingContent } from "src/lib/movieinfo/typeGuards";

export default interface ICommonDataStructure {
    isCinemaRelevant: boolean;
    filmwebMovieId?: string | null;
    isSeries: boolean;
    streamingId?: number;
    sanityImagePosterUrl?: string | null;
    imagesPoster?: ImageVersion[];
    title: string;
    year?: string | null;
    providerContents?: StreamingProviderContent[];
    hasCinemaShows: boolean;
    premiereCinema?: string;
}

export function convert(data: StreamingContent | WatchableContent): ICommonDataStructure {
    if (isStreamingContent(data)) {
        const sct = data
        return {
            isCinemaRelevant: false,
            isSeries: sct.isSeries,
            title: sct.title!,
            streamingId: sct.id,
            year: sct.year,
            imagesPoster: sct.imagesPoster as (ImageVersion[] | undefined),
            providerContents: sct.providerContents as (StreamingProviderContent[] | undefined),
            hasCinemaShows: false
        }
    } else {
        const wct = data;
        return {
            isCinemaRelevant: wct.isCinemaRelevant,
            isSeries: wct.isSeries,
            sanityImagePosterUrl: wct.sanityImagePosterUrl,
            imagesPoster: wct.imagesPosterStreaming as (ImageVersion[] | undefined),
            filmwebMovieId: wct.movieId,
            streamingId: wct.streamingContentId,
            title: wct.title!,
            year: wct.productionYear,
            providerContents: wct.streamingProviderContents as (StreamingProviderContent[] | undefined),
            hasCinemaShows: wct.hasCinemaShows,
            premiereCinema: wct.premiereCinema
        };
    }
}